export enum ParserError {
  ZodDeserializationError,
  ZodSerializationError,
  FunctionDeserializationError,
}
